import { Controller } from "@hotwired/stimulus"
import { showSystemToast } from "../utils/system_toast"

// Inline "Add name" editing on network list rows: clicking the Add name pill
// swaps in a text input right in the row; Enter/blur saves via PATCH
// /contacts/:id, Escape cancels. On success the row's title updates in place.
export default class extends Controller {
    static values = { url: String }
    static targets = ["button", "form", "input"]

    start(e) {
        e.preventDefault()
        e.stopPropagation()
        this.buttonTarget.hidden = true
        this.formTarget.hidden = false
        this.inputTarget.focus()
    }

    keydown(e) {
        if (e.key === "Enter") {
            e.preventDefault()
            this._save()
        } else if (e.key === "Escape") {
            e.preventDefault()
            this._cancel()
        }
    }

    blur() {
        if (this._saving) return
        if ((this.inputTarget.value || "").trim().length > 0) {
            this._save()
        } else {
            this._cancel()
        }
    }

    stopPropagation(e) {
        e.stopPropagation()
    }

    _cancel() {
        this.inputTarget.value = ""
        this.formTarget.hidden = true
        this.buttonTarget.hidden = false
    }

    _save() {
        let name = (this.inputTarget.value || "").trim()
        if (name.length === 0) return this._cancel()
        if (this._saving) return
        this._saving = true
        this.inputTarget.disabled = true

        fetch(this.urlValue, {
            method: "PATCH",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
            },
            credentials: "same-origin",
            body: JSON.stringify({ name })
        })
            .then((response) => response.json().then((data) => ({ response, data })))
            .then(({ response, data }) => {
                if (!response.ok || !data.ok) throw new Error(data.error || "Could not save that name.")
                this._applyName(data.display_name || name)
                showSystemToast("Name saved", { level: "success", duration: 2000 })
            })
            .catch((error) => {
                showSystemToast(error.message || "Could not save that name.", { level: "error", duration: 3000 })
                this.inputTarget.disabled = false
                this._saving = false
                this.inputTarget.focus()
            })
    }

    _applyName(displayName) {
        let row = this.element.closest(".contact-row")
        if (row) {
            row.classList.remove("contact-row--email-name")
            let compactTitle = row.querySelector(".contact-row-body--compact .msg-row-subject")
            if (compactTitle && compactTitle.firstChild) compactTitle.firstChild.textContent = displayName
            let expandedTitle = row.querySelector(".contact-row-title")
            if (expandedTitle) expandedTitle.textContent = displayName
            let avatarInitial = row.querySelector(".contact-avatar-initial")
            if (avatarInitial) avatarInitial.textContent = displayName.charAt(0).toUpperCase()
        }
        this.element.remove()
    }
}
